export function LoadingSpinner() {
  return (
    <span className="relative inline-block h-l w-l animate-loading-spinner-linear rounded-full border-[0.2rem] border-white/20 border-l-white" />
  );
}
